<template>
  <div style="
      background: white;
      color: black;
      margin: 0;
      padding: 0;
      height: 100%;
      width: 100%;
    " id="myDivCalen">
    <!-- <pre>{{get_data}}</pre> -->
    <div class="inner-div1">
      <vs-row class="al-center" vs-w="12">
        <vs-spacer />
        <h3>
          <b>{{ currentTime }}</b>
        </h3>
        <vs-icon v-if="showIcon" @click="hideSideBar('myDivCalen')" icon="zoom_out_map" size="25px"
          color="#6c757d"></vs-icon>
        <div class="img" v-else @click="showSideBar"></div>
      </vs-row>
      <vs-row style="width: 100%; height: 96vh" vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-lg="7" vs-sm="4" vs-xs="12">
          <vs-row>
            <vs-card style="
                background: rgba(255, 255, 255, 0.3);
                border-radius: 20px;
                position: relative;
              " class="container-fluid">
              <div class="mt-4" style="position: relative">
                <div v-for="i in iconvalue" :key="i">
                  <span :class="i.class">
                    <vs-icon @click="topath(i.path)" :id="i.class" style="color: rgba(255, 255, 255, 0)"
                      icon="child_care"></vs-icon>
                    <b-tooltip variant="light" :target="i.class">
                      <h6 class="thFontthai mb-1">
                        {{ i.name }}
                      </h6>
                      <img @click="topath(i.path)" style="height: 100%; width: 100%; cursor: pointer" :src="i.src" />
                    </b-tooltip>
                  </span>
                </div>
                <img class="imgMapResponsive" src="../../../../assets/images/kubota/mapoverview.gif" />


              </div>
            </vs-card>
            <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-col style="padding-left: 0" vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-card class="borderRD">
                  <vs-row>
                    <h3 class="mb-2 mt-1" style="font-weight: 800; font-size: 1vw">
                      O<sub>2</sub>, --PM2.5, PM10, O<sub>3</sub>, N<sub>2</sub>O,
                      CO<sub>2</sub> & CH<sub>4</sub>
                    </h3>
                    <vs-spacer />
                    <vs-select class="selectExample" @change="selectDataGraph(selectData, index)" v-model="selectData">
                      <vs-select-item :key="index" :value="item.value" :text="item.text"
                        v-for="(item, index) in options1" /></vs-select>
                  </vs-row>
                  <div style="position: relative; width: 100%">
                    <h1 v-if="graph_loading" class="graph_loading">Loading...</h1>
                    <LineChart v-else :width="800" :height="height_graph" :chartData="datacollection" :options="options">
                    </LineChart>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <img style="width: 100%" src="../../../../assets/images/kubota/Group 5319.png" /> </vs-col></vs-row>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-lg="5" vs-sm="4" vs-xs="12">
          <vs-row>
            <vs-row v-if="get_data.aqi <= 25" style="position: relative" class="mb-1">
              <img style="width: 100%; top: 0; left: 0" src="../../../../assets/images/kubota/airQ/Group 5358.png" />
              <div align="center" style="position: absolute; width: 100px; top: 12%; left: 27%">
                <h1 style="font-weight: 800; color: #061d61; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1 style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #061d61;
                    font-size: 3vw;
                  ">
                  Excellent
                </h1>
              </div>
            </vs-row>
            <vs-row v-if="25 < get_data.aqi && get_data.aqi <= 50" style="position: relative" class="mb-1">
              <img style="width: 100%; top: 0; left: 0" src="../../../../assets/images/kubota/airQ/Group 5357.png" />
              <div style="position: absolute; top: 12%; left: 27%">
                <h1 style="font-weight: 800; color: #1b6106; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 55%">
                <h1 style="font-weight: 800; color: #1b6106; font-size: 3vw">
                  GOOD
                </h1>
              </div>
            </vs-row>
            <vs-row v-if="50 < get_data.aqi && get_data.aqi <= 100" style="position: relative" class="mb-1">
              <img style="width: 100%; top: 0; left: 0" src="../../../../assets/images/kubota/airQ/Group 5356.png" />
              <div align="center" style="position: absolute; width: 100px; top: 12%; left: 27%">
                <h1 style="font-weight: 800; color: #5f6106; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1 style="font-weight: 800; color: #5f6106; font-size: 2.5vw">
                  MODERATE
                </h1>
              </div>
            </vs-row>
            <vs-row v-if="100 < get_data.aqi && get_data.aqi <= 200" style="position: relative" class="mb-1">
              <img style="width: 100%; top: 0; left: 0" src="../../../../assets/images/kubota/airQ/Group 5360.png" />
              <div align="center" style="position: absolute; width: 100px; top: 10%; left: 24%">
                <h1 style="font-weight: 800; color: #613706; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; top: 50%; left: 50%">
                <h1 style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #613706;
                    font-size: 2.6vw;
                  ">
                  Unhealthy
                </h1>
              </div>
            </vs-row>
            <vs-row v-if="get_data.aqi > 200" style="position: relative" class="mb-1">
              <img style="width: 100%; top: 0; left: 0" src="../../../../assets/images/kubota/airQ/Group 5359.png" />
              <div align="center" style="position: absolute; width: 100px; top: 10%; left: 24%">
                <h1 style="font-weight: 800; color: #610e06; font-size: 4vw">
                  {{ get_data.aqi }}
                </h1>
              </div>
              <div style="position: absolute; width: 100%; top: 50%; left: 45%">
                <h1 style="
                    font-weight: 800;
                    text-transform: uppercase;
                    color: #610e06;
                    font-size: 2vw;
                  ">
                  Very Unhealthy
                </h1>
              </div>
            </vs-row>

            <div class="centerHeader container">
              <h4 style="font-size: 1.4rem; font-weight: 500">
                Real Time Weather Conditions
              </h4>
            </div>
            <WeatherConditions :get_data="get_data" />

            <div class="centerHeader mb-2 container">
              <h4 style="font-size: 1.4rem; font-weight: 500">
                Real Time Air Pollution
              </h4>
            </div>

            <o2 :get_data="get_data" />
            <!-- <vs-card class="borderRD">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <h4 style="font-size: 1rem; font-weight: 400">Real time Air Pullution</h4>
              </vs-col>
            </vs-card> -->
            <vs-row class="mt-2" vs-align="flex-end" vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 2%; left: 7%">
                  <img style="height: 30%; width: 30%" src="../../../../assets/images/kubota/h gif/200-2.gif" />
                </div>
                <div>
                  <img v-if="get_data.pm25 <= 25" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                  <img v-if="25 < get_data.pm25 && get_data.pm25 <= 37" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png" />
                  <img v-if="37 < get_data.pm25 && get_data.pm25 <= 50" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png" />
                  <img v-if="50 < get_data.pm25 && get_data.pm25 <= 90" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png" />
                  <img v-if="get_data.pm25 > 90" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png" />
                </div>

                <div style="position: absolute; top: 8%; left: 39%">
                  <h2 style="font-size: 1.6rem; font-weight: 800">PM 2.5</h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.pm25 <= 25" class="mr-2 pTextSize pTextL1">
                    {{ get_data.pm25 }}
                  </h1>
                  <h1 v-if="25 < get_data.pm25 && get_data.pm25 <= 37" class="mr-2 pTextSize pTextL2">
                    {{ get_data.pm25 }}
                  </h1>
                  <h1 v-if="37 < get_data.pm25 && get_data.pm25 <= 50" class="mr-2 pTextSize pTextL3">
                    {{ get_data.pm25 }}
                  </h1>
                  <h1 v-if="50 < get_data.pm25 && get_data.pm25 <= 90" class="mr-2 pTextSize pTextL4">
                    {{ get_data.pm25 }}
                  </h1>
                  <h1 v-if="get_data.pm25 > 90" class="mr-2 pTextSize pTextL5">
                    {{ get_data.pm25 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">
                    µg./m <sup>3</sup>
                  </h2>
                </div>
                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -5.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ฝุ่นละอองขนาดเล็กไม่เกิน 2.5 ไมครอน
                  </h6>
                </div>
              </vs-col>
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 0%; left: 5.5%">
                  <img style="height: 30%; width: 30%" src="../../../../assets/images/kubota/h gif/bubbles.gif" />
                </div>
                <div>
                  <img v-if="get_data.pm10 <= 50" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                  <img v-if="50 < get_data.pm10 && get_data.pm10 <= 80" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png" />
                  <img v-if="80 < get_data.pm10 && get_data.pm10 <= 120"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png" />
                  <img v-if="120 < get_data.pm10 && get_data.pm10 <= 180"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png" />
                  <img v-if="get_data.pm10 > 180" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png" />
                </div>

                <div style="position: absolute; top: 8%; left: 39%">
                  <h2 style="font-size: 1.6rem; font-weight: 800">PM 10</h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.pm10 <= 50" class="mr-2 pTextSize pTextL1">
                    {{ get_data.pm10 }}
                  </h1>
                  <h1 v-if="50 < get_data.pm10 && get_data.pm10 <= 80" class="mr-2 pTextSize pTextL2">
                    {{ get_data.pm10 }}
                  </h1>
                  <h1 v-if="80 < get_data.pm10 && get_data.pm10 <= 120" class="mr-2 pTextSize pTextL3">
                    {{ get_data.pm10 }}
                  </h1>
                  <h1 v-if="120 < get_data.pm10 && get_data.pm10 <= 180" class="mr-2 pTextSize pTextL4">
                    {{ get_data.pm10 }}
                  </h1>
                  <h1 v-if="get_data.pm10 > 180" class="mr-2 pTextSize pTextL5">
                    {{ get_data.pm10 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">
                    µg./m <sup>3</sup>
                  </h2>
                </div>
                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ฝุ่นละอองขนาดเล็กไม่เกิน 10 ไมครอน
                  </h6>
                </div>
              </vs-col>
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 1%; left: 2.5%">
                  <img style="height: 40%; width: 40%" src="../../../../assets/images/kubota/h gif/sd.gif" />
                </div>
                <div>
                  <img v-if="get_data.o3 <= 35" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                  <img v-if="35 < get_data.o3 && get_data.o3 <= 50" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png" />
                  <img v-if="50 < get_data.o3 && get_data.o3 <= 70" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png" />
                  <img v-if="70 < get_data.o3 && get_data.o3 <= 120" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png" />
                  <img v-if="get_data.o3 > 120" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png" />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    O<sub>3</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.o3 <= 35" class="mr-2 pTextSize pTextL1">
                    {{ get_data.o3 }}
                  </h1>
                  <h1 v-if="35 < get_data.o3 && get_data.o3 <= 50" class="mr-2 pTextSize pTextL2">
                    {{ get_data.o3 }}
                  </h1>
                  <h1 v-if="50 < get_data.o3 && get_data.o3 <= 70" class="mr-2 pTextSize pTextL3">
                    {{ get_data.o3 }}
                  </h1>
                  <h1 v-if="70 < get_data.o3 && get_data.o3 <= 120" class="mr-2 pTextSize pTextL4">
                    {{ get_data.o3 }}
                  </h1>
                  <h1 v-if="get_data.o3 > 120" class="mr-2 pTextSize pTextL5">
                    {{ get_data.o3 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppb</h2>
                </div>
                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -5.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซโอโซน
                  </h6>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-2" vs-align="center" vs-type="flex" vs-justify="space-around" vs-w="12">
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 1%; left: 10%">
                  <img style="height: 20%; width: 30%"
                    src="../../../../assets/images/kubota/h gif/output-onlinegiftools (33).gif" />
                </div>
                <div>
                  <img v-if="get_data.no2 < 50" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                  <img v-if="get_data.no2 >= 50" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png" />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    N<sub>2</sub>O
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.no2 < 50" class="mr-2 pTextL1 pTextSize">
                    {{ get_data.no2 }}
                  </h1>
                  <h1 v-if="get_data.no2 >= 50" class="mr-2 pTextL3 pTextSize">
                    {{ get_data.no2 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>
                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ไนตรัสออกไซด์
                  </h6>
                </div>
              </vs-col>
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 1%; left: 8%">
                  <img style="height: 20%; width: 35%"
                    src="../../../../assets/images/kubota/h gif/210319adcffc99fe1a3ad496bae53d98.gif" />
                </div>
                <div>
                  <!-- <img
                    v-if="get_data.co2 <= 4.4"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png"
                  />
                  <img
                    v-if="4.4 < get_data.co2 && get_data.co2 <= 6.4"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5336.png"
                  />
                  <img
                    v-if="6.4 < get_data.co2 && get_data.co2 <= 9"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png"
                  />
                  <img
                    v-if="9 < get_data.co2 && get_data.co2 <= 30"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5340.png"
                  />
                  <img
                    v-if="get_data.co2 > 30"
                    style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Moon and Stairs Mystical Logo Template (9).png"
                  /> -->
                  <img style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    CO<sub>2</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 class="mr-2 pTextSize pTextL1">{{ get_data.co2 }}</h1>
                  <!-- <h1 v-if="get_data.co2 <= 4.4" class="mr-2 pTextSize pTextL1">
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="4.4 < get_data.co2 && get_data.co2 <= 6.4"
                    class="mr-2 pTextSize pTextL2"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="6.4 < get_data.co2 && get_data.co2 <= 9"
                    class="mr-2 pTextSize pTextL3"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1
                    v-if="9 < get_data.co2 && get_data.co2 <= 30"
                    class="mr-2 pTextSize pTextL4"
                  >
                    {{ get_data.co2 }}
                  </h1>
                  <h1 v-if="get_data.co2 > 30" class="mr-2 pTextSize pTextL5">
                    {{ get_data.co2 }}
                  </h1> -->
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>
                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซคาร์บอนไดออกไซด์
                  </h6>
                </div>
              </vs-col>
              <vs-col style="position: relative" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <div style="position: absolute; top: 0%; left: 11%">
                  <img style="height: 40%; width: 25%"
                    src="../../../../assets/images/kubota/h gif/ezgif.com-gif-maker (7).gif" />
                </div>
                <div>
                  <img v-if="get_data.ch4 < 1000" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5317@2x.png" />
                  <img v-if="get_data.ch4 >= 1000" style="height: 100%; width: 100%; top: 0; left: 0"
                    src="../../../../assets/images/kubota/Group 5337.png" />
                </div>

                <div style="position: absolute; top: 8%; text-align: center">
                  <h2 style="font-size: 1.6rem; font-weight: 800">
                    CH<sub>4</sub>
                  </h2>
                </div>
                <div style="position: absolute; top: 45%">
                  <h1 v-if="get_data.ch4 < 1000" class="mr-2 pTextSize pTextL1">
                    {{ get_data.ch4 }}
                  </h1>
                  <h1 v-if="get_data.ch4 >= 1000" class="mr-2 pTextSize pTextL3">
                    {{ get_data.ch4 }}
                  </h1>
                </div>

                <div style="position: absolute; top: 35%; right: 15%">
                  <h2 style="font-size: 1vw; font-weight: 400">ppm</h2>
                </div>

                <div style="
                    position: absolute;
                    text-align: center;
                    bottom: -4.5%;
                    margin: 10%;
                  ">
                  <h6 class="thFontthai" style="font-size: 0.68vw">
                    ก๊าซมีเทน
                  </h6>
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mt-1">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <img style="width: 100%" src="../../../../assets/images/kubota/Group 5320.png" /> </vs-col></vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import PureVueChart from "pure-vue-chart";
import LineChart from "./Chart.js";
import moment from "moment";
import WeatherConditions from "./components/WeatherConditions.vue";
import o2 from "./components/o2.vue";
// import BarChart from "./PM2.5/BarChart.vue";
// import LineChartSmall from "./PM2.5/lineChart.vue";
// import LineChart from "./PM2.5/Chart.js";
export default {
  name: "App",
  components: {
    PureVueChart,
    LineChart,
    WeatherConditions,
    o2,
  },

  data: () => ({
    get_data: [],
    currentTime: "",
    interval: null,
    iconvalue: [
      {
        name: "โซนเกษตรแม่นยำข้าวและพืชหลังนา",
        class: "icon1",
        path: "/riceplan",
        src: require("../../../../assets/images/kubota/Screenshot_155 (1).png"),
      },
      {
        name: "ทางเข้าอาคารเกษตรชัยพัฒน์",
        class: "icon2",
        path: "/solarplan",
        src: require("../../../../assets/images/kubota/solar.jpeg"),
      },
      {
        name: "เกษตรทฤษฎีใหม่",
        class: "icon3",
        path: "/plant3",
        src: require("../../../../assets/images/kubota/kubotap/3.gif"),
      },
      {
        name: "ยางพาราปาล์มน้ำมัน",
        class: "icon4",
        path: "/plant4",
        src: require("../../../../assets/images/kubota/kubotap/4.gif"),
      },
      {
        name: "เกษตรสมัยใหม่พืชไร่",
        class: "icon5",
        path: "/plant5",
        src: require("../../../../assets/images/kubota/kubotap/5.gif"),
      },
      {
        name: "หน้าอาคารเกษตรวิวัฒน์",
        class: "icon6",
        path: "/plant6",
        src: require("../../../../assets/images/kubota/kubotap/6.gif"),
      },
      {
        name: "Name Pending...",
        class: "icon7",
        path: "/plant7",
        src: require("../../../../assets/images/kubota/kubotap/7.gif"),
      },
      {
        name: "Name Pending...",
        class: "icon8",
        path: "/plant8",
        src: require("../../../../assets/images/kubota/kubotap/8.gif"),
      },
    ],
    options1: [
      {
        text: "Daily",
        value: 2,
        label: [
          "0 AM",
          "1 AM",
          "2 AM",
          "3 AM",
          "4 AM",
          "5 AM",
          "6 AM",
          "7 AM",
          "8 AM",
          "9 AM",
          "10 AM",
          "11 AM",
          "12 AM",
          "1 PM",
          "2 PM",
          "3 PM",
          "4 PM",
          "5 PM",
          "6 PM",
          "7 PM",
          "8 PM",
          "9 PM",
          "10 PM",
          "11 PM",
        ],
        data: [
          120, 190, 199, 14, 200, 120, 190, 199, 14, 200, 120, 190, 224, 14,
          200, 120, 190, 199, 14, 200, 120, 190, 199, 14,
        ],
      },
      {
        text: "Weekly",
        value: 3,
        data: [200, 200, 231, 14, 3, 20, 32],
        label: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
      },
      {
        text: "Monthly",
        value: 4,
        data: [200, 101, 231, 14],
        label: ["Week 1", "Week 2", "Week 3", "Week 4"],
      },
      {
        text: "Yearly",
        value: 5,
        data: [200, 200, 231, 14, 3, 20, 32, 22, 100, 90, 100, 300],
        label: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
    ],
    WeatherCon: [
      {
        header: "Temperature",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "26.3",
        unit: "c",
      },
      {
        header: "Relative Humidity",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "6",
        unit: "%",
      },
      {
        header: "Wind Speed",
        img: "../../../../assets/images/kubota/h gif/output-onlinegiftools (26).gif",
        number: "1",
        unit: "m/s",
      },
    ],
    showIcon: true,
    selectDataCompare1: 3,
    selectDataCompare2: 3,
    selectDataYearly: 0,
    optionsCompare1: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompare2: [
      { text: "Daily", value: 0 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    optionsCompareYearly: [
      { text: "2020", value: 0 },
      { text: "2019", value: 2 },
      { text: "2018", value: 3 },
      { text: "2017", value: 2 },
      { text: "2016", value: 3 },
    ],
    options: null,
    selectData: 2,
    users: [
      {
        id: 1,
        name: "NO2",
        number: "4",
      },
      {
        id: 2,
        name: "O2",
        number: "6",
      },
      {
        id: 3,
        name: "SO2",
        number: "1",
      },
    ],
    users2: [
      {
        id: 1,
        name: "Temp",
        number: "4",
      },
      {
        id: 2,
        name: "Humidity",
        number: "6",
      },
      {
        id: 3,
        name: "Wind",
        number: "1",
      },
    ],
    chartdata1: [],
    chartdata2: [],
    chartdata3: [],
    chartdata4: [],
    chartdata5: [],
    chartdata6: [],
    chartDataTime1: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime2: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime3: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime4: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime5: { daily: [], weekly: [], monthly: [], yearly: [] },
    chartDataTime6: { daily: [], weekly: [], monthly: [], yearly: [] },
    labelInput: [],
    labelInputTime: { daily: [], weekly: [], monthly: [], yearly: [] },
    height: 300,
    datacollection: null,
    gradient: null,
    intervalid1: null,
    intervaltime: null,
    intervaltime2: null,
    changes: null,
    airq: "",
    data_graph: [],
    height_graph: null,
    graph_loading: true
  }),
  methods: {
    topath(item) {
      this.$router.push(item);
    },
    todashsolar() {
      this.$router.push("/solarpant");
    },
    increase() {
      this.height += 10;
    },
    hideshow() {
      var cells = document.getElementById("tab").getElementsByTagName("td"),
        i = 0,
        c;
      var chb = document
        .getElementById("chboxes")
        .getElementsByTagName("input");
      while ((c = cells[i++])) {
        c.style.display = chb[c.cellIndex].checked ? "" : "none";
      }
    },
    setEvent() {
      var chb = document
        .getElementById("chboxes")
        .getElementsByTagName("input"),
        i = 0,
        c;
      while ((c = chb[i++])) {
        if (c.type == "checkbox") {
          c.onclick = function () {
            hideshow();
          };
        }
      }
    },
    selectDataGraph(item) {
      // console.log('KubotaFarm.selectDataGraph.chartDataTime1', this.chartDataTime1);
      // console.log('KubotaFarm.selectDataGraph.chartDataTime2', this.chartDataTime2);
      // console.log('KubotaFarm.selectDataGraph.chartDataTime3', this.chartDataTime3);
      // console.log('KubotaFarm.selectDataGraph.chartDataTime4', this.chartDataTime4);
      // console.log('KubotaFarm.selectDataGraph.chartDataTime5', this.chartDataTime5);
      // console.log('KubotaFarm.selectDataGraph.chartDataTime6', this.chartDataTime6);
      this.chartdata1 = [];
      this.chartdata2 = [];
      this.chartdata3 = [];
      this.chartdata4 = [];
      this.chartdata5 = [];
      this.chartdata6 = [];
      this.labelInput = [];

      if (item == 1) {
        this.chartdata1 = this.chartDataTime1;
        this.chartdata2 = this.chartDataTime2;
        this.chartdata3 = this.chartDataTime3;
        this.chartdata4 = this.chartDataTime4;
        this.chartdata5 = this.chartDataTime5;
        this.chartdata6 = this.chartDataTime6;
        this.labelInput = this.labelInputTime;
      } else if (item == 2) {
        this.chartdata1 = this.chartDataTime1.daily;
        this.chartdata2 = this.chartDataTime2.daily;
        this.chartdata3 = this.chartDataTime3.daily;
        this.chartdata4 = this.chartDataTime4.daily;
        this.chartdata5 = this.chartDataTime5.daily;
        this.chartdata6 = this.chartDataTime6.daily;
        this.labelInput = this.labelInputTime.daily;
      } else if (item == 3) {
        this.chartdata1 = this.chartDataTime1.weekly;
        this.chartdata2 = this.chartDataTime2.weekly;
        this.chartdata3 = this.chartDataTime3.weekly;
        this.chartdata4 = this.chartDataTime4.weekly;
        this.chartdata5 = this.chartDataTime5.weekly;
        this.chartdata6 = this.chartDataTime6.weekly;
        this.labelInput = this.labelInputTime.weekly;
      } else if (item == 4) {
        this.chartdata1 = this.chartDataTime1.monthly;
        this.chartdata2 = this.chartDataTime2.monthly;
        this.chartdata3 = this.chartDataTime3.monthly;
        this.chartdata4 = this.chartDataTime4.monthly;
        this.chartdata5 = this.chartDataTime5.monthly;
        this.chartdata6 = this.chartDataTime6.monthly;
        this.labelInput = this.labelInputTime.monthly;
      } else if (item == 5) {
        this.chartdata1 = this.chartDataTime1.yearly;
        this.chartdata2 = this.chartDataTime2.yearly;
        this.chartdata3 = this.chartDataTime3.yearly;
        this.chartdata4 = this.chartDataTime4.yearly;
        this.chartdata5 = this.chartDataTime5.yearly;
        this.chartdata6 = this.chartDataTime6.yearly;
        this.labelInput = this.labelInputTime.yearly;
      }
      // console.log(
      //   'KubotaFarm.selectDataGraph.chartData', 
      //   this.chartdata1,
      //   this.chartdata2,
      //   this.chartdata3,
      //   this.chartdata4,
      //   this.chartdata5,
      //   this.chartdata6,
      //   this.labelInput
      // );

      let chartdata7 = Array.from(
        { length: this.chartdata1.length },
        (v, i) => 28.03
      );
      this.datacollection = {
        labels: this.labelInput,
        datasets: [
          {
            label: "PM 2.5",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: this.chartdata1,
            borderWidth: 2,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "PM 10",
            data: this.chartdata2,
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(20, 153, 242,.9)",
          },
          {
            label: "O3",
            backgroundColor: "rgba(255, 0, 0,.0)",
            data: this.chartdata3,
            borderWidth: 2,
            borderColor: "rgba(250, 128, 114,.9)",
          },
          {
            label: "N2O",
            data: this.chartdata4,
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(211, 84, 0,.9)",
          },
          {
            label: "CO2",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: this.chartdata5,
            borderWidth: 2,
            borderColor: "rgba(241, 196, 15,.9)",
          },
          {
            label: "CH4",
            data: this.chartdata6,
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(22, 160, 133,.9)",
          },
          {
            label: "O2",
            data: chartdata7,
            backgroundColor: "rgba(20, 153, 242,.0)",
            borderWidth: 2,
            borderColor: "rgba(219, 18, 44,.9)",
          },
        ],
      };

      // console.log('KubotaFarm.selectDataGraph.datacollection', this.datacollection);

      this.options = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
        },
      };

      // console.log('KubotaFarm.selectDataGraph.options', this.options);
    },
    getLabel(num) {
      return moment(num).format("dddd");
    },
    getMonth(num) {
      if (num == 1) {
        return "January";
      } else if (num == 2) {
        return "February";
      } else if (num == 3) {
        return "March";
      } else if (num == 4) {
        return "April";
      } else if (num == 5) {
        return "May";
      } else if (num == 6) {
        return "June";
      } else if (num == 7) {
        return "July";
      } else if (num == 8) {
        return "August";
      } else if (num == 9) {
        return "September";
      } else if (num == 10) {
        return "October";
      } else if (num == 11) {
        return "November";
      } else if (num == 12) {
        return "December";
      }
    },
    async getData() {
      this.graph_loading = true
      this.chartDataTime1 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.chartDataTime2 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.chartDataTime3 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.chartDataTime4 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.chartDataTime5 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.chartDataTime6 = { daily: [], weekly: [], monthly: [], yearly: [] };
      this.labelInputTime = { daily: [], weekly: [], monthly: [], yearly: [] };

      Promise.all([this.$API.get("kubota/new_graph/daily"), this.$API.get("kubota/new_graph/weekly"), this.$API.get("kubota/new_graph/monthly"), this.$API.get("kubota/new_graph/yearly")])
        .then(([daily, weekly, monthly, yearly]) => {
          // ########## Daily ##########
          this.labelInputTime.daily = daily.data.label
          this.chartDataTime1.daily = daily.data.pm25
          this.chartDataTime2.daily = daily.data.pm10
          this.chartDataTime3.daily = daily.data.o3
          this.chartDataTime4.daily = daily.data.no2
          this.chartDataTime5.daily = daily.data.co2
          this.chartDataTime6.daily = daily.data.ch4

          // ########## Weekly ##########
          this.labelInputTime.weekly = weekly.data.label
          this.chartDataTime1.weekly = weekly.data.pm25
          this.chartDataTime2.weekly = weekly.data.pm10
          this.chartDataTime3.weekly = weekly.data.o3
          this.chartDataTime4.weekly = weekly.data.no2
          this.chartDataTime5.weekly = weekly.data.co2
          this.chartDataTime6.weekly = weekly.data.ch4

          // ########## Monthly ##########
          this.labelInputTime.monthly = monthly.data.label
          this.chartDataTime1.monthly = monthly.data.pm25
          this.chartDataTime2.monthly = monthly.data.pm10
          this.chartDataTime3.monthly = monthly.data.o3
          this.chartDataTime4.monthly = monthly.data.no2
          this.chartDataTime5.monthly = monthly.data.co2
          this.chartDataTime6.monthly = monthly.data.ch4

          // ########## Yearly ##########
          this.labelInputTime.yearly = yearly.data.label
          this.chartDataTime1.yearly = yearly.data.pm25
          this.chartDataTime2.yearly = yearly.data.pm10
          this.chartDataTime3.yearly = yearly.data.o3
          this.chartDataTime4.yearly = yearly.data.no2
          this.chartDataTime5.yearly = yearly.data.co2
          this.chartDataTime6.yearly = yearly.data.ch4

          this.graph_loading = false
          this.selectDataGraph(2)
        })

      // await this.$API
      //   .get("kubota/graph/daily")
      //   .then((result) => {
      //     // console.log('Graph.Daily', result.data);
      //     this.data_graph = result.data;
      //     check = true;
      //     sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //     j = parseInt(
      //       moment(
      //         moment(result.data[0].timestamp).subtract(7, "hours")
      //       ).format("HH")
      //     );
      //     // console.log(result.data[0].timestamp, j);
      //     result.data.forEach((element) => {
      //       sum["o3"] += parseFloat(element["o3"]);
      //       sum["ch4"] += parseFloat(element["ch4"]);
      //       sum["no2"] += parseFloat(element["no2"]);
      //       sum["co2"] += parseFloat(element["co2"]);
      //       sum["pm25"] += parseFloat(element["pm25"]);
      //       sum["pm10"] += parseFloat(element["pm10"]);
      //       divider++;
      //       // console.log(element.timestamp);
      //       if (
      //         moment(element.timestamp).isSame(
      //           today + "T" + (j < 10 ? "0" + j : j) + ":00:00.000Z",
      //           "hour"
      //         ) &&
      //         check
      //       ) {
      //         // this.dailyData.push(element.newmessage.pm25)
      //         // console.log(sum,divider)
      //         this.labelInputTime.daily.push(j < 12 ? j + "AM" : j - 10 + "PM");
      //         this.chartDataTime1.daily.push(
      //           (sum["pm25"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime2.daily.push(
      //           (sum["pm10"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime3.daily.push((sum["o3"] / divider).toFixed(2));
      //         this.chartDataTime4.daily.push((sum["no2"] / divider).toFixed(2));
      //         this.chartDataTime5.daily.push((sum["co2"] / divider).toFixed(2));
      //         this.chartDataTime6.daily.push((sum["ch4"] / divider).toFixed(2));
      //         check = false;
      //         sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //         divider = 1;
      //         j++;
      //       } else check = true;
      //     });
      //     // console.log(this.chartDataTime3);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // await this.$API
      //   .get("kubota/graph/weekly")
      //   .then((result) => {
      //     // console.log('Graph.Weekly', result.data);
      //     check = true;
      //     sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //     j = parseInt(moment(moment(result.data[0].timestamp)).format("DD"));
      //     divider = 1;
      //     // console.log(result.data)
      //     result.data.forEach((element) => {
      //       sum["o3"] += parseFloat(element["o3"]);
      //       sum["ch4"] += parseFloat(element["ch4"]);
      //       sum["no2"] += parseFloat(element["no2"]);
      //       sum["co2"] += parseFloat(element["co2"]);
      //       sum["pm25"] += parseFloat(element["pm25"]);
      //       sum["pm10"] += parseFloat(element["pm10"]);
      //       divider++;
      //       // console.log('API.check.result', element.timestamp,month+'-'+(j<10 ? '0'+j : j)+'T00:00:00.000Z','day',moment(element.timestamp).isSame(month+'-'+(j<10 ? '0'+j : j)+'T00:00:00.000Z','day'))
      //       if (
      //         moment(element.timestamp.split('T')[0] + 'T00:00:00.000Z').isSame(
      //           month + "-" + (j < 10 ? "0" + j : j) + "T00:00:00.000Z",
      //           "day"
      //         ) &&
      //         check
      //       ) {
      //         // console.log('API.this.chartDataTime1', element)
      //         this.labelInputTime.weekly.push(this.getLabel(element.timestamp));
      //         this.chartDataTime1.weekly.push(
      //           (sum["pm25"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime2.weekly.push(
      //           (sum["pm10"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime3.weekly.push((sum["o3"] / divider).toFixed(2));
      //         this.chartDataTime4.weekly.push(
      //           (sum["no2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime5.weekly.push(
      //           (sum["co2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime6.weekly.push(
      //           (sum["ch4"] / divider).toFixed(2)
      //         );
      //         check = false;
      //         sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //         divider = 1;
      //         j += 1;
      //       } else {
      //         check = true;
      //       }
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // await this.$API
      //   .get("kubota/graph/monthly")
      //   .then((result) => {
      //     // console.log('Graph.Monthly', result.data);
      //     check = true;
      //     sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //     j = parseInt(moment(moment(result.data[0].timestamp)).format("DD"));
      //     divider = 1;
      //     // console.log(result.data)
      //     result.data.forEach((element) => {
      //       sum["o3"] += parseFloat(element["o3"]);
      //       sum["ch4"] += parseFloat(element["ch4"]);
      //       sum["no2"] += parseFloat(element["no2"]);
      //       sum["co2"] += parseFloat(element["co2"]);
      //       sum["pm25"] += parseFloat(element["pm25"]);
      //       sum["pm10"] += parseFloat(element["pm10"]);
      //       divider++;
      //       // console.log(element.timestamp,month+'-'+(j<10 ? '0'+j : j)+'T00:00:00.000Z','day',moment(element.timestamp).isSame(month+'-'+(j<10 ? '0'+j : j)+'T00:00:00.000Z','day'))
      //       if (
      //         moment(element.timestamp.split('T')[0] + 'T00:00:00.000Z').isSame(
      //           month + "-" + (j < 10 ? "0" + j : j) + "T00:00:00.000Z",
      //           "day"
      //         ) &&
      //         check
      //       ) {
      //         // console.log(
      //         //   'Graph.Monthly.isSame', 
      //         //   element.timestamp.split('T')[0] + 'T00:00:00.000Z', 
      //         //   month + "-" + (j < 10 ? "0" + j : j) + "T00:00:00.000Z",
      //         //   element
      //         // )

      //         // console.log("Cal J is " + j, "Week " + (Math.floor(j / 7) + 1))
      //         this.labelInputTime.monthly.push("Week " + (Math.floor(j / 7) + 1));
      //         this.chartDataTime1.monthly.push(
      //           (sum["pm25"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime2.monthly.push(
      //           (sum["pm10"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime3.monthly.push(
      //           (sum["o3"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime4.monthly.push(
      //           (sum["no2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime5.monthly.push(
      //           (sum["co2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime6.monthly.push(
      //           (sum["ch4"] / divider).toFixed(2)
      //         );
      //         check = false;
      //         sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //         divider = 1;
      //         j += 7;
      //       } else {
      //         check = true;
      //       }
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // await this.$API
      //   .get("kubota/graph/yearly")
      //   .then((result) => {
      //     // console.log('Graph.Yearly', result.data);
      //     check = true;
      //     sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //     j = 1;
      //     divider = 1;
      //     // console.log(result.data);
      //     result.data.forEach((element) => {
      //       sum["o3"] += parseFloat(element["o3"]);
      //       sum["ch4"] += parseFloat(element["ch4"]);
      //       sum["no2"] += parseFloat(element["no2"]);
      //       sum["co2"] += parseFloat(element["co2"]);
      //       sum["pm25"] += parseFloat(element["pm25"]);
      //       sum["pm10"] += parseFloat(element["pm10"]);
      //       divider++;
      //       if (moment(element.timestamp).month() + 1 > j) {
      //         this.labelInputTime.yearly.push(this.getMonth(j));
      //         this.chartDataTime1.yearly.push(0);
      //         this.chartDataTime2.yearly.push(0);
      //         this.chartDataTime3.yearly.push(0);
      //         this.chartDataTime4.yearly.push(0);
      //         this.chartDataTime5.yearly.push(0);
      //         this.chartDataTime6.yearly.push(0);
      //         j++;
      //       }
      //       if (
      //         moment(moment(element.timestamp).format("YYYY-MM")).isSame(
      //           year + "-" + (j < 10 ? "0" + j : j),
      //           "month"
      //         ) &&
      //         check
      //       ) {
      //         // console.log(sum,divider)
      //         this.labelInputTime.yearly.push(
      //           moment(element.timestamp).format("MMMM")
      //         );
      //         this.chartDataTime1.yearly.push(
      //           (sum["pm25"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime2.yearly.push(
      //           (sum["pm10"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime3.yearly.push((sum["o3"] / divider).toFixed(2));
      //         this.chartDataTime4.yearly.push(
      //           (sum["no2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime5.yearly.push(
      //           (sum["co2"] / divider).toFixed(2)
      //         );
      //         this.chartDataTime6.yearly.push(
      //           (sum["ch4"] / divider).toFixed(2)
      //         );
      //         check = false;
      //         sum = { o3: 0, ch4: 0, no2: 0, co2: 0, pm25: 0, pm10: 0 };
      //         divider = 1;
      //         j++;
      //       } else {
      //         check = true;
      //       }
      //     });
      //     // console.log(this.yearlyData)
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

    },
    hideShowTableCol(colName, checked) {
      // console.log(colName, checked);
      const cells = document.querySelectorAll(`.${colName}`);
      cells.forEach((cell) => {
        cell.style.display = checked ? "table-cell" : "none";
      });
    },
    showChart(data, label) {
      // console.log(data);
      // dummy data
      // var data = [12, 19, 1, 14, 3, 10, 9];
      var dataOne = data;
      var labels = dataOne.map((x, i) => i.toString());

      // other dataOne color
      var color = dataOne.map((x) => "rgba(128, 182, 244, 0.6)");

      // change max color
      color[this.argMax1(dataOne)] = "rgb(54, 162, 235, 0.75)";
      this.datacollection = {
        labels: label,
        responsive: true,
        datasets: [
          {
            label: "Data One",
            backgroundColor: color,
            // backgroundColor: purple_orange_gradient,
            // hoverBackgroundColor: purple_orange_gradient,
            hoverBorderColor: "purple",
            hoverBorderWidth: 2,

            // backgroundColor: gradientFill,
            borderWidth: 4,
            data: dataOne,
          },
        ],
      };
    },
    hideSideBar(id) {
      var element = document.getElementById(id);
      this.showIcon = false;
      // Supports most browsers and their versions.
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    showSideBar() {
      location.reload();
    },
    argMax1(array) {
      // console.log(array);
      return array
        .map((x, i) => [x, i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    argMax2(array) {
      // console.log(array);
      return array
        .map((x, i) => [x, i])
        .reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    todo() {
      //  this.changes = Math.floor(Math.random() * (50 - 5 + 1)) + 5 ;
      //  return this.changes
      // console.log(
      //   this.chartdata6
      // );
      this.addNewDataGraph(this.selectData);
      // this.changes = Math.floor(Math.random() * (50 - 5 + 1)) + 5 ;
      // console.log(this.changes);
    },
    timeout300m() {
      this.interval = setTimeout(async () => {
        await this.getData();
        this.selectDataGraph(this.selectData);
        this.timeout300m()
      }, 300 * 1000);
    },
    timeout30s() {
      this.intervaltime2 = setTimeout(async () => {
        await this.$API.get("kubota/currentdata").then((result) => {
          this.get_data = result.data;
          this.timeout30s()
        });
      }, 30 * 1000);
    },
  },
  async mounted() {
    // var x = window.matchMedia("(max-width: 1170px)");
    // console.log(x);
    // this.myFunction(x);
    this.currentTime = this.$moment().format("DD/MM/YYYY HH:mm:ss")

    // this.fillData();
    this.$vs.loading();
    await this.getData();
    this.selectDataGraph(this.selectData);
    this.$API.get("kubota/currentdata").then((result) => {
      this.get_data = result.data;
      this.$vs.loading.close();
    });
    this.timeout300m()
    this.timeout30s()
    //  usage: realtime clock
    this.intervaltime = setInterval(async () => {
      this.currentTime = this.$moment().format("DD/MM/YYYY HH:mm:ss")
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    clearInterval(this.intervaltime);
    clearTimeout(this.intervaltime2);
  },
  created() {
    console.log(window.innerWidth);
    if (window.innerWidth < 1550) {
      this.height_graph = 240;
    } else if (window.innerWidth > 1550) {
      this.height_graph = 320;
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    myStyles() {
      return {
        // height: `${this.height}px`,
        position: "relative",
        color: "linear-gradient(#e66465, #9198e5)",
      };
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Kodchasan:wght@500&display=swap");

.small {
  max-width: 800px;
  height: 450px;
}

.thFontthai {
  font-family: "Charm", cursive;
  font-family: "Kodchasan", sans-serif;
}

.icon1 {
  position: absolute;
  cursor: pointer;
  top: 59%;
  right: 9.5%;
  z-index: 100;
}

.icon2 {
  position: absolute;
  cursor: pointer;
  top: 68%;
  right: 16.7%;
  z-index: 100;
}

.icon3 {
  position: absolute;
  cursor: pointer;
  top: 24%;
  right: 31.5%;
  z-index: 100;
}

.icon4 {
  position: absolute;
  cursor: pointer;
  top: 17%;
  right: 41.5%;
  z-index: 100;
}

.icon5 {
  position: absolute;
  cursor: pointer;
  top: 34%;
  left: 43.5%;
  z-index: 100;
}

.icon6 {
  position: absolute;
  cursor: pointer;
  top: 60%;
  right: 36.5%;
  z-index: 100;
}

.icon7 {
  position: absolute;
  cursor: pointer;
  top: 46%;
  right: 13%;
  z-index: 100;
}

.icon8 {
  position: absolute;
  cursor: pointer;
  top: 49%;
  right: 3%;
  z-index: 100;
}

.small {
  max-width: 800px;
  height: 450px;
}

.inner-div1 {
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 5px 10px;
  margin-right: 0px;
  float: left;
  background-image: url("../../../../assets/images/kubota/131_1.jpg");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.imgMapResponsive {
  display: block;
  height: 36vh;
  width: 100%;
  top: 0;
  left: 0;
}

.pTextSize {
  font-size: 3vw;
  font-weight: 800;
}

.pTextL1 {
  color: #0cbbc4;
}

.pTextL2 {
  color: #2bc40c;
}

.pTextL3 {
  color: #c4b50c;
}

.pTextL4 {
  color: #c47d0c;
}

.pTextL5 {
  color: #c41c0c;
}

@media only screen and (max-width: 600px) {
  .inner-div1 {
    background-image: none;
  }
}

.hidden {
  display: inline-block;
}

div.con {
  background-image: url("../../../../assets/images/Enco/Rectangle -10.png");
}

.opacityCard {
  opacity: 0.8;
}

.a {
  background: #caebbd;
  padding: 5px;
  border-radius: 5px;
  height: 45%;
}

.b {
  background: #fbe988;
  padding: 5px;
  border-radius: 5px;
  height: 45%;
}

.w {
  background-image: url("../../../../assets/images/Enco/Rectangle 1718.png");
}

.bg-div2 {
  background: #caebbd;
  width: 100%;
  border-radius: 20px;
  height: 100%;
  text-align: center;
}

.ug-detail {
  margin-top: 1.3rem;
  margin-bottom: 0rem;
  font-size: 0.8rem;
}

.borderRD {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  margin-bottom: 0;
}

.borderGreen {
  background: rgba(50, 192, 64, 0.3);
  position: relative;
  height: 100%;
}

.al-center {
  align-items: center;
}

.brdbtn {
  width: 80px;
  border-radius: 20px;
}

.img {
  width: 30px;
  height: 30px;
  display: inline-block;
  -webkit-mask: url("../../../../assets/images/kubota/1x/baseline_zoom_in_map_black_24dp.png") center/contain;
  mask: url("../../../../assets/images/kubota/1x/baseline_zoom_in_map_black_24dp.png") center/contain;
  color: rgba(255, 255, 255, 0);
  cursor: pointer;
}

.img:hover {
  background: #000000;
}

.centerHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 5px;
}

@keyframes loading {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.graph_loading {
  height: 300px;
  text-align: center;
  padding: 150px 0;
  animation: loading 1s linear infinite;
}
</style>
